import styled from 'styled-components';
import { Text } from '../common';

export function PopupInfo({ origin, location }) {
  return (
    <StyledPopupInfo>
      {origin?.name !== 'unknown' && (
        <PopupSection>
          <Text>First Seen in:</Text>
          <PopupValue>{origin?.name}</PopupValue>
        </PopupSection>
      )}

      {location?.name !== 'unknown' && (
        <PopupSection>
          <Text>Last known location:</Text>
          <PopupValue>{location?.name}</PopupValue>
        </PopupSection>
      )}
    </StyledPopupInfo>
  );
}

const StyledPopupInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 40px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const PopupSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  max-width: 48%;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

const PopupValue = styled.p`
  color: #83bf46;
`;
